module.exports = __webpack_public_path__ + "assets/images/amountofPlants-02.38771481ae4e3b4e1522360cd6007792.svg";